import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { accountAccessShowLogin, modalClose } from 'actions/UiActions'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import { EUROPE_REGIONS } from 'constants/config/region'

function useEuropeOfferPageWalledGarden() {
  const dispatch = useAppDispatch()

  const countryCode = useAppSelector(state => state.geo.currentRegionCode)
  const hasPassesWalledGarden = useAppSelector(hasPassedWalledGarden)

  const isEurope = useMemo(() => EUROPE_REGIONS.has(countryCode), [countryCode])

  useEffect(() => {
    if (!isEurope || hasPassesWalledGarden) return

    dispatch(accountAccessShowLogin('login', false))

    return () => {
      dispatch(modalClose())
    }
  }, [countryCode, dispatch, hasPassesWalledGarden, isEurope])

  return isEurope
}

export default useEuropeOfferPageWalledGarden
